<script setup lang="ts">

</script>

<template>
    <TransitionGroup move-class="transistion duration-700 ease-in-out delay-500"
        enter-active-class="transistion duration-700 ease-in-out delay-500"
        leave-active-class="absolute transistion duration-700 ease-in-out delay-500"
        enter-from-class="opacity-0 scale-y-[0.01] translate-x-8"
        leave-to-class="opacity-0 scale-y-[0.01] translate-x-8">
        <slot></slot>
    </TransitionGroup>
</template>